const Testimonials = (() => {
  const DOM = {};
  let options,
    slideWidth,
    fullWidth,
    slidesLength,
    posInitial,
    posFinal,
    index = 0,
    posX1 = 0,
    posX2 = 0,
    translateX,
    newX = 0,
    travel = 0,
    slide = 0,
    interval,
    allowShift = true;

  const cacheDOM = () => {
    const { containerClass, carouselClass, nextClass, prevClass } = options;
    DOM.container = document.getElementsByClassName(`${containerClass}`); // ?

    if (DOM.container.length > 0) {
      DOM.carousel = document.getElementsByClassName(`${carouselClass}`);
      DOM.slides = Array.from(DOM.carousel[0].children);
    }
  };

  const dragStart = (e) => {
    e = e || window.event;
    e.preventDefault();

    DOM.carousel[0].classList.remove("shifting");

    let style = window.getComputedStyle(DOM.carousel[0])
    let transformation = style.transform || style.webkitTransform || style.mozTransform

    translateX = (new WebKitCSSMatrix(transformation)).m41;

    if ('touchstart' === e.type) {
      posX1 = e.touches[0].clientX;
    } else {
      posX1 = e.clientX;
      document.onmouseup = dragEnd;
      document.onmousemove = dragAction;
    }
  };

  const dragAction = (e) => {
    e = e || window.event;

    posX2 = 'touchmove' === e.type ? e.touches[0].clientX : posX2 = e.clientX;
    let posMove = posX2 - posX1;
    newX = translateX + posMove;

    DOM.carousel[0].style.transform = "translateX(" + newX + "px)";
  };

  const dragEnd = () => {
    DOM.carousel[0].classList.add("shifting");

    posFinal = translateX;
    let targetSlide = Math.round(newX / slideWidth)
    targetSlide = targetSlide > 0 ? 0 : Math.abs(targetSlide);

    moveToSlide(targetSlide)
    setClass(targetSlide)

    document.onmouseup = null;
    document.onmousemove = null;

  };

  const shiftSlide = (dir) => {
    DOM.carousel[0].classList.add("shifting");

    if (allowShift) {
      if (dir === 1) {
        slide++;
        slide <= slidesLength - 1 ? moveToSlide(slide) : moveToSlide(0);
      }
    }

    if (slide) {
      checkIndex()
    }
  };


  const moveToSlide = (targetSlide) => {
    DOM.carousel[0].classList.add("shifting");

    if (targetSlide.dataset) {
      setClass(targetSlide.dataset.value);
      slide = parseInt(targetSlide.dataset.value);
    } else {
      slide = targetSlide;
    }

    if (slide === 0) {
      DOM.carousel[0].style.transform = "translateX(-" + 0 + "px)";
    } else if (slide > 0) {
      travel = slideWidth * slide;
      let maxTravel = fullWidth - DOM.container[0].offsetWidth;

      travel = travel > maxTravel ? maxTravel : travel;

      DOM.carousel[0].style.transform = "translateX(-" + travel + "px)";
    }

  };

  const checkIndex = () => {
    allowShift = true;
  }

  const setClass = (targetSlide) => {
    if (targetSlide === DOM.slides.length) {
      targetSlide = 0;
    }

    for (let i = 0; i < DOM.slides.length; i++) {
      DOM.slides[i].classList.remove("active");
    }

    DOM.slides[targetSlide].classList.add("active");
  };

  const setupCarousel = () => {
    DOM.container[0].style.width = DOM.container[0].offsetWidth +"px"
    DOM.slides.forEach( (item) => {
      item.style.width = DOM.container[0].offsetWidth - 20 + "px";
    });

    // DOM.carousel[0].style.width = DOM.container[0].offsetWidth * 3 +"px";
    DOM.carousel[0].style.width = DOM.container[0].offsetWidth * DOM.slides.length +"px";

    slideWidth = DOM.slides[0].offsetWidth;
    slidesLength = DOM.slides.length;

    let style =
      DOM.slides[0].currentStyle || window.getComputedStyle(DOM.slides[0]);

    slideWidth = slideWidth + parseFloat(style.marginLeft) + parseFloat(style.marginRight);

    fullWidth = slideWidth * DOM.slides.length;


  };

  const setupEventListeners = () => {
    DOM.slides[0].classList.add("active");

    //Mouse and Touch events
    DOM.carousel[0].onmousedown = dragStart;

    // Touch events
    DOM.carousel[0].addEventListener("touchstart", dragStart);
    DOM.carousel[0].addEventListener("touchmove", dragAction);
    DOM.carousel[0].addEventListener("touchend", dragEnd);

    window.addEventListener('resize', () => {
      setupCarousel();
    })

    DOM.carousel[0].addEventListener('transitionend', checkIndex);

    interval = setInterval(() => {
      shiftSlide(1)
    }, 6000)

  };

  function init(customOptions) {
    const defaults = {
      containerClass: "js-testimonials__container",
      carouselClass: "js-testimonials__list",
    };

    options = Object.assign(defaults, customOptions);

    cacheDOM();

    if (DOM.container.length > 0) {
      setupCarousel();
      setupEventListeners();
    }
  }

  return { init };
})();

export default Testimonials;
